<template>
  <div class="modal-actions">
    <sp-button
      variant="outlined"
      color="primary"
      :disabled="store.isSubmitting"
      :data-testid="TestId.canonicalUpdate.cancelButton"
      @click="store.close()"
    >
      {{ store.labels.cancel }}
    </sp-button>

    <sp-button
      variant="flat"
      color="primary"
      :disabled="store.confirmDisabled"
      :data-testid="TestId.canonicalUpdate.confirmButton"
      @click="store.confirm()"
    >
      {{ store.labels.confirm }}
    </sp-button>
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { useCanonicalUpdateStore } from "#ce/apps/SpAdmin/SpCanonicalUpdateApp/store/canonical-update";

const store = useCanonicalUpdateStore();
</script>

<style scoped lang="scss">
.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-ref-scale-8);
  width: 100%;
  padding-block: var(--sp-ref-scale-16);
  padding-inline: var(--sp-ref-scale-24);
  border-top: var(--sp-ref-spacing-px) solid var(--sp-sys-color-outline);

  /* SpButton reads -background-color (not -background); without these the
   * disabled Confirm button renders transparent — i.e. invisible until its
   * preconditions enable it. The button must always be visible, just disabled. */
  --sp-comp-button-disabled-background-color: var(--sp-sys-color-disabled);
  --sp-comp-button-disabled-text-color: var(--sp-sys-color-on-disabled);
}
</style>
